import { HttpInterceptorFn } from "@angular/common/http";
import { inject } from "@angular/core";
import { Router } from "@angular/router";
import { catchError, throwError } from "rxjs";
import { clearSession } from "../shared/utils/session.util";

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const token = localStorage.getItem("token");
  const router = inject(Router);

  // Agregar token a la petición si existe
  if (token) {
    const cloned = req.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`,
      },
    });

    return next(cloned).pipe(
      catchError((error) => {
        // Si el error es 401 (Unauthorized), cerrar sesión y redirigir al login
        if (error.status === 401) {
          clearSession();

          // Redirigir al login
          router.navigate(["/login"]);
        }

        return throwError(() => error);
      })
    );
  }

  // Si no hay token, también manejar errores 401 (aunque es menos común)
  return next(req).pipe(
    catchError((error) => {
      if (error.status === 401) {
        clearSession();

        // Redirigir al login
        router.navigate(["/login"]);
      }

      return throwError(() => error);
    })
  );
};
